import { Const } from "../../../../Const";
import { LayaGL } from "../../../../layagl/LayaGL";
import { Vector4 } from "../../../../maths/Vector4";
import { BaseTexture } from "../../../../resource/BaseTexture";
import { Texture } from "../../../../resource/Texture";
import { Texture2D } from "../../../../resource/Texture2D";
import { BlendModeHandler } from "../../../canvas/BlendMode";
import { ShaderDefines2D } from "../ShaderDefines2D";
const _TEMP_CLIPDIR = new Vector4(Const.MAX_CLIP_SIZE, 0, 0, Const.MAX_CLIP_SIZE);
export class GraphicsShaderInfo {
    constructor() {
        this.shaderData = LayaGL.renderDeviceFactory.createShaderData();
        this.toDefault();
    }
    toDefault() {
        this.clipMatDir = _TEMP_CLIPDIR;
        this.clipMatPos = Vector4.ZERO;
        this.vertexSize = Vector4.ZERO;
        BlendModeHandler.initBlendMode(this.shaderData);
        this.shaderData.addDefine(ShaderDefines2D.TEXTURESHADER);
        this.textureHost = null;
        this.enableVertexSize = false;
        this.materialClip = false;
        this.fillTexture = false;
    }
    get textureHost() {
        return this._textureHost;
    }
    set textureHost(value) {
        this._textureHost = value;
        let textrueReadGamma = false;
        if (this.textureHost) {
            if (this.textureHost instanceof BaseTexture) {
                textrueReadGamma = this.textureHost.gammaCorrection != 1;
            }
            else if (this.textureHost instanceof Texture && this.textureHost.bitmap) {
                textrueReadGamma = this.textureHost.bitmap.gammaCorrection != 1;
            }
        }
        if (textrueReadGamma) {
            this.shaderData.addDefine(ShaderDefines2D.GAMMATEXTURE);
        }
        else {
            this.shaderData.removeDefine(ShaderDefines2D.GAMMATEXTURE);
        }
        let tex;
        if (value instanceof Texture) {
            tex = value.bitmap;
        }
        else {
            tex = value;
        }
        if (!tex) {
            tex = Texture2D.whiteTexture;
        }
        this.shaderData.setTexture(ShaderDefines2D.UNIFORM_SPRITETEXTURE, tex);
    }
    set enableVertexSize(value) {
        if (value) {
            this.shaderData.addDefine(ShaderDefines2D.VERTEX_SIZE);
        }
        else {
            this.shaderData.removeDefine(ShaderDefines2D.VERTEX_SIZE);
        }
    }
    get enableVertexSize() {
        return this.shaderData.hasDefine(ShaderDefines2D.VERTEX_SIZE);
    }
    set vertexSize(value) {
        this.shaderData.setVector(ShaderDefines2D.UNIFORM_VERTEX_SIZE, value);
    }
    get vertexSize() {
        return this.shaderData.getVector(ShaderDefines2D.UNIFORM_VERTEX_SIZE);
    }
    set materialClip(value) {
        if (value) {
            this.shaderData.addDefine(ShaderDefines2D.MATERIALCLIP);
        }
        else {
            this.shaderData.removeDefine(ShaderDefines2D.MATERIALCLIP);
        }
    }
    get materialClip() {
        return this.shaderData.hasDefine(ShaderDefines2D.MATERIALCLIP);
    }
    set clipMatDir(value) {
        this.shaderData.setVector(ShaderDefines2D.UNIFORM_MATERIAL_CLIPMATDIR, value);
    }
    get clipMatDir() {
        return this.shaderData.getVector(ShaderDefines2D.UNIFORM_MATERIAL_CLIPMATDIR);
    }
    set clipMatPos(value) {
        this.shaderData.setVector(ShaderDefines2D.UNIFORM_MATERIAL_CLIPMATPOS, value);
    }
    get clipMatPos() {
        return this.shaderData.getVector(ShaderDefines2D.UNIFORM_MATERIAL_CLIPMATPOS);
    }
    get u_TexRange() {
        return this.shaderData.getVector(ShaderDefines2D.UNIFORM_TEXRANGE);
    }
    set u_TexRange(value) {
        this.shaderData.setVector(ShaderDefines2D.UNIFORM_TEXRANGE, value);
    }
    set fillTexture(value) {
        if (value) {
            this.shaderData.addDefine(ShaderDefines2D.FILLTEXTURE);
        }
        else {
            this.shaderData.removeDefine(ShaderDefines2D.FILLTEXTURE);
        }
    }
    get fillTexture() {
        return this.shaderData.hasDefine(ShaderDefines2D.FILLTEXTURE);
    }
    cloneTo(shaderData) {
        if (this.enableVertexSize) {
            shaderData.addDefine(ShaderDefines2D.VERTEX_SIZE);
            shaderData.setVector(ShaderDefines2D.UNIFORM_VERTEX_SIZE, this.vertexSize);
        }
        if (this.materialClip) {
            shaderData.addDefine(ShaderDefines2D.MATERIALCLIP);
            shaderData.setVector(ShaderDefines2D.UNIFORM_MATERIAL_CLIPMATDIR, this.clipMatDir);
            shaderData.setVector(ShaderDefines2D.UNIFORM_MATERIAL_CLIPMATPOS, this.clipMatPos);
        }
        let textrueReadGamma = this.shaderData.hasDefine(ShaderDefines2D.GAMMATEXTURE);
        if (textrueReadGamma) {
            shaderData.addDefine(ShaderDefines2D.GAMMATEXTURE);
        }
        else {
            shaderData.removeDefine(ShaderDefines2D.GAMMATEXTURE);
        }
        let tex = this._textureHost.bitmap;
        if (!tex) {
            tex = this._textureHost;
        }
        let fill = this.shaderData.hasDefine(ShaderDefines2D.FILLTEXTURE);
        if (fill) {
            shaderData.addDefine(ShaderDefines2D.FILLTEXTURE);
            shaderData.setVector(ShaderDefines2D.UNIFORM_TEXRANGE, this.u_TexRange);
        }
        else {
            shaderData.removeDefine(ShaderDefines2D.FILLTEXTURE);
        }
        shaderData.setTexture(ShaderDefines2D.UNIFORM_SPRITETEXTURE, tex);
    }
    clear() {
        this.toDefault();
    }
    destroy() {
        this.shaderData.destroy();
        this._textureHost = null;
    }
}
